<template>
  <div class="dayReport">
    <div class="search_form">
      <el-form :inline="true" :model="searchForm">
        <el-form-item>
          <el-date-picker v-model="searchForm.workDate" value-format="yyyy-MM" type="month" placeholder="选择月" :clearable='false'>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-cascader
            v-model="searchForm.depart"
            :options="treeData"
            :props='defaultProps'
            placeholder='请选择部门'
            ref="refHandle"
            @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.user" filterable placeholder="请选择人员">
            <el-option
              v-for="item in users"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searForm">查询</el-button>
          <el-button type="primary" icon="el-icon-refresh-right" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="operation">
      <!-- <el-button type="primary" icon="el-icon-plus" @click="addTwo('add')">新增</el-button> -->
      <!-- <el-button type="primary" icon="el-icon-plus" @click="saleAdd('add')">销售新增</el-button>       -->
      <!-- <el-button type="primary" icon="el-icon-edit" @click="editOrAdd('edit')">修改</el-button> -->
      <!-- <el-button type="primary" icon="el-icon-delete" @click="del">删除</el-button> -->
    </div>
    <div class="dataList">
      <div class="dataNums">
        <div class="nums">
        <div>
          <span class="el-icon-time"></span>
          {{searchForm.workDate}}
        </div>
        <div>本月应写日志 / 计划
          <span>{{nums.shouldWrite}}</span> 篇， 实写日志
          <span>{{nums.normal+nums.ago+nums.later}}</span> 篇，计划
          <span>{{nums.normal+nums.ago+nums.later}}</span> 篇</div>
        </div>
        <!-- <div class="cz" v-if="selfValue">
          <span>产值自评合计：<span class="red">{{selfValue}}</span></span>
          <span>元</span>
        </div> -->
      </div>
      <el-collapse v-model="activeName">
        <el-collapse-item :name='index' v-for="(item,index) in tableData" :key="index">
          <template slot="title">
            <div class="name" :class="{'border':activeName.indexOf(index)>-1}">
              <div :class="activeName.indexOf(index)>-1?'setBag':'setDiv'">
                <span class="el-icon-date"></span>
                <span class="time">{{item.workDate}}</span>
                <span class="time time2">{{weekDay[item.weekDay]}}</span>
              </div>
              <span class="createT">创建时间：{{item.createTime}}</span>
            </div>
          </template>
          <div class="conts">
            <div class="listP">
              <div class="tip2" style="margin-top:15px;padding-bottom:0;">
                <span>日志</span>
              </div>
              <!-- <div class="flexOne" v-for="(item2,index2) in item.dailyWorkDetails" :key="index2" v-if="item2.workHours">
                <div class="title">
                  <img src="../../../assets/img/index.jpg" alt=""> {{item2.typeName}}
                  <span>{{item2.workHours}}小时</span>
                </div>
                <div class="cont" v-html="item2.content">
                </div>
              </div> -->
              <div class="saleCont" v-for="(item2,index2) in item.dailyWorkDetails" :key="'o'+index2" v-if="item2.workHours">
                <div class="flexSale">
                  <div>
                    <span>项目名称</span>
                    <span style="color:#007AFF">{{item2.typeName}}</span>
                  </div>
                  <div>
                    <span>工作时长</span>
                    <span>{{item2.workHours}}小时</span>
                  </div>
                  <div v-if="item2.outputValue">
                    <span>产值</span>
                    <span>{{item2.outputValue}}元</span>
                  </div>
                </div>
                <div class="flexSale flexMar">
                  <span>内容</span>
                  <span v-html="item2.content"></span>
                </div>
              </div>
              <!-- 销售内容 -->
              <div class="saleCont" v-if="item.saleDailyWorkDetails" v-for="(item2,index) in item.saleDailyWorkDetails" :key="index">
                <div class="flexSale">
                  <div>
                    <span>内容类型</span>
                    <span style="color:#007AFF">{{item2.dailyDetailTypeName}}</span>
                  </div>
                  <div v-if="item2.dailyDetailType=='xm'">
                    <span>项目名称</span>
                    <span>{{item2.itemName}}</span>
                  </div>
                  <div v-if="item2.dailyDetailType=='kh'">
                    <span>客户名称</span>
                    <span>{{item2.customerName}}</span>
                  </div>
                  <div>
                    <span>跟进方式</span>
                    <span>{{item2.followWayName}}</span>
                  </div>
                </div>
                <div class="flexSale flexMar">
                  <span>内容</span>
                  <span>{{item2.followResult}}</span>
                </div>
              </div>
            </div>
            <div class="listP" v-if="item.planDate" style="margin-top:10px;">
              <div class="tip2">
                <span>计划</span>
              </div>
              <div class="flexSale flexSale2">
                <span>计划时间</span>
                <span>{{item.planDate}}</span>
              </div>
              <div class="flexSale flexSale2 flexMar">
                <span>计划内容</span>
                <span>{{item.planContent}}</span>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-if="tableData.length==0" class="noData">暂无数据</div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { checkPhone, checkEmail } from "@/utils/validate.js";
export default {
  data() {
    return {
      searchForm: {
        depart: [],
        workDate: ""
      },
      tableData: [],
      pageIndex: 0,
      pageSize: 31,
      totalNum: 0,
      activeName: [],
      workDate: "",
      nums: {},
      defaultProps:{
        children: 'children',
        label:'departName',
        value:'orgCode',
        checkStrictly: true
      },
      treeData:[],
      weekDay:['周日','周一','周二','周三','周四','周五','周六'],
      users:[],
      selfValue:''
    };
  },
  computed: {
    ...mapGetters(["ownInfo"])
  },
  beforeRouteEnter (to, from, next) {
    // ...
    console.log(to)
    if(to.query.type==1){
      to.meta.title = '全部日志/计划'
    }else{
      to.meta.title = '部门日志/计划'
    }
    next();
  },
  created() {
    if(this.$route.query.type==1){
      this.$store.dispatch("getAllDepartTree").then(res => {
        this.treeData = res.body.data;
      });
    }else{
      this.$store.dispatch("getDepartTree").then(res => {
        this.treeData = res.body.data;
      });
    }
    

    var that = this;
    for (var i = 0; i < 32; i++) {
      that.activeName.push(i);
    }
    var date = new Date();
    this.workDate =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
      if(!this.$route.query.month){
        this.searchForm.workDate =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1);
      }else{
        this.searchForm.workDate = this.$route.query.month;
      }
    

    this.resetData();
  },
  methods: {
    getSelfValue(month,id){
      this.$store.dispatch('findSelfOutput',{month:month,userId:id}).then(res =>{
        if(res.body.data){
          this.selfValue = res.body.data
        }else{
          this.selfValue = ''
        }
      })
    },
    handleChange(val){
      if (this.$refs.refHandle) {
				this.$refs.refHandle.dropDownVisible = false; //监听值发生变化就关闭它
      }
      this.$set(this.searchForm,'user','')
      this.$store.dispatch('getPeopleByDepartCode',{orgCode:val[val.length-1]}).then(res => {
        this.users = res.body.data;
      })
    },
    resetData() {
      var param = {
        queryParams: [
          {
            key: "workDate",
            value: this.searchForm.workDate,
            logic: "Contain",
            innerLinkMode: "And"
          },
          {
            key: "dailyWorkType",
            value: this.searchForm.dailyWorkType,
            logic: "Equal",
            innerLinkMode: "And"
          },
          {
            key: "createBy",
            value: this.searchForm.user?Number(this.searchForm.user):Number(this.ownInfo.id),
            logic: "Equal",
            innerLinkMode: "And"
          }
        ],
        sortParams: [
          {
            key: "workDate",
            order: "DESC"
          }
        ],
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$store.dispatch("getDailyWorkPage", { body: param }).then(res => {
        res.body.data.content.forEach(item => {
          if (item.workDate) {
            item.weekDay = new Date(item.workDate).getDay();
          }
        });
        this.tableData = res.body.data.content;
        this.totalNum = res.body.data.totalElements;
      });
      this.getSelfValue(this.searchForm.workDate,this.searchForm.user?Number(this.searchForm.user):Number(this.ownInfo.id))
      this.$store
        .dispatch("getUserDailyCount", { month: this.searchForm.workDate,userId:this.searchForm.user?Number(this.searchForm.user):Number(this.ownInfo.id)})
        .then(res => {
          this.nums = res.body.data;
        });
    },
    pageChange(val) {
      this.pageIndex = val - 1;
      this.resetData();
    },
    searForm() {
      if(this.searchForm.depart && this.searchForm.depart.length && this.searchForm.depart.length>0){
        if(!this.searchForm.user){
           this.$message({
            message: '请选择人员',
            type: 'warning'
          });
          return;
        }
      }
      this.pageIndex = 0;
      this.resetData();
    },
    resetForm() {
      this.searchForm.dailyWorkType = "";
      this.searchForm.depart = [];
      this.searchForm.user = "";      
      var date = new Date();
      this.searchForm.workDate =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1);
      this.pageIndex = 0;
      this.resetData();
    },

    toDetail(item) {
      var that = this;
      this.info = item;
      this.dialogInfo = true;
    }
  }
};
</script>
<style lang="less" scoped>
.dayReport {
  padding: 15px;
  .setBorder {
    p {
      font-size: 16px;
      color: #308ff0;
      padding-left: 10px;
      border-left: 2px solid #308ff0;
      margin-bottom: 15px;
    }
    .border {
      .el-textarea {
        width: 715px;
      }
    }
  }
  .saleCont {
    border-bottom: 1px solid #eee;
    padding: 10px 20px 15px 20px;
  }
  .flexSale {
    display: flex;
    font-size: 14px;
    &.flexSale2 {
      padding: 0 20px;
    }
    div {
      display: flex;
      width: 33%;
    }
    span:nth-child(1) {
      color: #aaaaaa;
      padding-right: 10px;
      width: 60px;
      text-align: right;
    }
    span:nth-child(2) {
      flex: 1;
      white-space: pre-wrap;
    }
    &.flexMar {
      margin-top: 10px;
    }
  }
  .btns {
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    margin-bottom: 10px;
    span {
      margin-left: 40px;
      font-size: 16px;
      cursor: pointer;
      &.del {
        color: #fe080e;
      }
      &.add {
        color: #308ff0;
      }
    }
  }
  .sale {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-left: 15px;
    & > span {
      font-size: 16px;
      color: #308ff0;
      padding-left: 10px;
      border-left: 2px solid #308ff0;
    }
    div {
      font-size: 14px;
      color: #aaa;
      margin-left: 40px;
      span:nth-child(1) {
        margin-right: 5px;
      }
    }
  }
  .listP {
    .tip2 {
      span:nth-child(1) {
        font-size: 16px;
        border-left: 2px solid #308ff0;
        padding-left: 10px;
        color: #308ff0;
      }
      span:nth-child(2) {
        font-size: 14px;
        padding-left: 20px;
      }
      padding-bottom: 10px;
    }
  }
  .dataNums{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .red{
      color: #f56c6c;
      padding-right: 5px;
    }
  }
  .nums {
    display: flex;
    align-items: center;
    margin-top: 20px;
    
    div {
      margin-right: 20px;
      &:nth-child(2) {
        span {
          color: #f56c6c;
        }
      }
    }
  }
  .workDate {
    ::v-deep .el-form-item__label {
      width: 90px !important;
    }
  }
  .tip {
    color: #aaaaaa;
    padding-left: 20px;
  }
  .noData {
    padding: 200px 0 50px 0;
    text-align: center;
  }
  .formDialog {
    .formRow {
      ::v-deep .el-input {
        width: 570px;
      }
    }
    .el-collapse {
      margin-top: 0;
    }
    .el-textarea {
      width: 570px;
    }
  }
  ::v-deep .el-collapse {
    margin-top: 20px;
    border-color: #eee;
    border-top: none;
    .el-collapse-item__wrap {
      border-color: #eee;
    }
    .el-collapse-item {
      margin-bottom: 15px;
      box-shadow: 0px 2px 6px #eee;
      border-top: 1px solid #eee;
    }
    .formOne {
      .el-collapse-item {
        padding: 0px 20px;
        .el-collapse-item__header {
          font-weight: 600;
        }
        .el-collapse-item__content {
          border-top: 1px solid #eee;
          padding-top: 15px;
        }
        .el-form-item__label {
          margin: 0;
          padding: 0;
        }
      }
    }
    .el-collapse-item.is-disabled .el-collapse-item__header {
      color: #333;
    }
    .el-collapse-item__header {
      border-color: #eee;
      position: relative;
      &.is-active {
        border-color: transparent;
      }
    }
    .el-icon-date {
      font-size: 16px;
      margin-right: 5px;
      color: #666;
    }
    .flexOne {
      // padding-left: 28px;
    }
    .conts {
      padding: 0px 15px;
      .flexOne {
        padding-bottom: 15px;
      }
      .title {
        display: flex;
        align-items: center;
        img {
          width: 25px;
          // vertical-align: middle;
          margin-right: 6px;
        }
        font-size: 15px;
        span {
          padding-left: 20px;
        }
      }
      .cont {
        white-space: pre-wrap;
        padding-left: 32px;
        color: #666;
        margin-top: 10px;
        line-height: 24px;
        font-size: 14px;
      }
    }
    .name {
      display: flex;
      align-items: center;
      font-size: 15px;
      // padding: 0 15px;
      width: 100%;
      border-bottom: 1px solid transparent;
      &.border {
        border-bottom: 1px solid #007aff;
      }
      .time {
        margin: 0px 20px 0px 5px;
        &.time2 {
          margin-left: 20px;
        }
      }
      .createT {
        color: #999;
        margin-left: 30px;
      }
      .setDiv {
        padding-left: 20px;
      }
      .setBag {
        background: #007aff;
        color: #fff;
        padding-left: 20px;
        .el-icon-date {
          color: #fff;
        }
      }
      .posAb {
        position: absolute;
        font-size: 14px;
        right: 40px;
        display: flex;
        cursor: pointer;
        span {
          margin-left: 20px;
          color: #007aff;
        }
      }
    }
  }
  .formOne {
    // border: 1px solid #ddd;
    // box-shadow: 0px 2px 6px #eee;
    // padding: 5px 15px 5px 15px;
    margin-bottom: 15px;
    ::v-deep .el-textarea {
      width: 675px;
    }
    ::v-deep .el-input {
      width: 50px;
      margin-left: 15px;
      position: relative;
      top: 5px;
      input {
        border: none;
        border-bottom: 1px solid #ccc;
        padding: 0;
        text-align: center;
        height: 22px;
        line-height: 22px;
      }
    }
    .formFlex {
      display: flex;
      align-items: center;
      span:nth-child(1) {
        max-width: 580px;
      }
    }
  }
}
</style>
